/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line jira/filename-case
import type { HTMLAttributes } from 'react';
import { cssMap, keyframes } from '@compiled/react';
import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		animationDelay: '0s',
		animationDuration: '1s',
		animationFillMode: 'forwards',
		animationIterationCount: 'infinite',
		animationName: keyframes({
			'0%': {
				backgroundPosition: '-300px 0',
			},
			'100%': {
				backgroundPosition: '1700px 0',
			},
		}),
		animationTimingFunction: 'linear',
		backgroundColor: token('color.skeleton'),
		backgroundImage: `linear-gradient( to right, ${token('color.skeleton')} 10%, ${token('color.skeleton.subtle')} 30%, ${token('color.skeleton')} 50% )`,
		backgroundRepeat: 'no-repeat',
		borderRadius: token('radius.xsmall'),
	},
});

type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
	height?: string | number;
	width?: string | number;
};

export const Skeleton = ({ children, className, height, width, style, ...rest }: SkeletonProps) => {
	return (
		<div
			{...rest}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- to support "styled" wrappers
			className={className}
			css={styles.root}
			// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- to support dynamic styles
			style={{ ...style, height, width }}
		>
			{children}
		</div>
	);
};
